module.exports = __webpack_public_path__ + "media/thirdSection/4-9608fb46.png";